/**
 * Compact page list for CMS pagination: e.g. 1 … 4 5 6 … 20
 * @param {number} currentPage - 1-based
 * @param {number} totalPages - total page count
 * @param {number} windowSize - pages shown around current (default 5)
 * @returns {(number|'ellipsis')[]}
 */
export function buildPaginationItems(currentPage, totalPages, windowSize = 5) {
    const total = totalPages;
    if (total <= 0) {
        return [];
    }
    const cur = Math.max(1, Math.min(Number(currentPage) || 1, total));
    if (total <= windowSize + 2) {
        return Array.from({ length: total }, (_, i) => i + 1);
    }
    let winEnd = Math.min(total, Math.max(windowSize, cur + Math.floor(windowSize / 2)));
    let winStart = Math.max(1, winEnd - windowSize + 1);
    winEnd = Math.min(total, winStart + windowSize - 1);
    winStart = Math.max(1, winEnd - windowSize + 1);
    const items = [];
    if (winStart > 1) {
        items.push(1);
        if (winStart > 2) items.push('ellipsis');
    }
    for (let p = winStart; p <= winEnd; p++) items.push(p);
    if (winEnd < total) {
        if (winEnd < total - 1) items.push('ellipsis');
        items.push(total);
    }
    return items;
}
